import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AppUpdateBanner } from "./components/AppUpdateBanner";
import { captureInstallPrompt } from "./lib/install-prompt";
import { registerServiceWorker } from "./lib/service-worker";
import { requestPersistentStorage } from "./lib/storage-persistence";
import "./styles.css";

captureInstallPrompt();
void requestPersistentStorage();
// /sw.js is only emitted by the production build, so registering in dev would 404 on every load.
if (import.meta.env.PROD) registerServiceWorker();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <TooltipProvider delay={250}>
      {/* Outside App, which returns early on most routes before rendering any shared chrome. */}
      <App />
      <AppUpdateBanner />
    </TooltipProvider>
  </StrictMode>,
);
